import { TeamMemberComponent } from './../TeamMemberManagement/TeamMember';
import { Component, ElementRef, Input, OnInit,ViewChild, OnDestroy, Output, EventEmitter } from '@angular/core';
import {EditKeyTrackerService} from '../../Services/edit-key-tracker.service';
import { PrimeProfile } from '../TeamMemberManagement/TeamMember';


@Component({
  selector: 'app-edit-key-tracker',
  templateUrl: './edit-key-tracker.component.html',
  styleUrls: ['./edit-key-tracker.component.css']
})
export class EditKeyTrackerComponent implements OnInit, OnDestroy {

    @Input() UserID : number = 0;
    @Input() FieldName : string;
    @Input() FieldValue: string;
    @Input() DisplayLabelText : string;
    @Input() profiles: PrimeProfile[];
    @Input() hdnLOVID: number;
    @Input() Show: boolean = false;
    @Output() fieldValueChange = new EventEmitter();
    @Output() showChange = new EventEmitter();
    @Output() TeamMember = new EventEmitter();

    public teamMemberCodeValue: string;
    editteammembervalidation:boolean;
    fieldChangeHistory = [];
    result: any;
    isnametake1 : boolean;

   constructor(private editKeyTrackerService: EditKeyTrackerService) {

    }
   ngOnInit(): void {
 this.editteammembervalidation=false;
    }

    Cancel(){

      this.editteammembervalidation = false;
      this.isnametake1 = false;
    this.showChange.emit(false);
    }

    Save(){

      let TeamMemberComponent : TeamMemberComponent;
//TeamMemberComponent.validateInputName(this.FieldValue);
        if(this.FieldValue != "")
        {
            this.isnametake1 = false;
            this.editteammembervalidation=false;
            if (this.validateInputName(this.FieldValue)) {

                    this.isnametake1 = true;

                    return this.isnametake1;
            }
        this.editteammembervalidation = false;
    this.saveFieldValue(this.FieldValue);
        }
        else
        {
           this.editteammembervalidation = true;
        }
    }
     validateInputName(teamMemberCode: any) {
       let isNameTake = false;
       var obj = this.profiles;
       for (var i = 0; i < obj.length; i++) {
           if (obj[i].hasOwnProperty("teamMemberCode")) {
               if (obj[i]["teamMemberCode"] != 0 && obj[i]["teamMemberCode"] != null) {
                   if (this.hdnLOVID > 0) {
                       if (obj[i]["teamMemberCode"] == teamMemberCode && obj[i]["id"] != this.hdnLOVID) {
                         isNameTake = true;

                           return isNameTake;
                       }

                   }
                   else {
                       if (obj[i]["teamMemberCode"] == teamMemberCode) {
                           isNameTake = true;
                           return isNameTake;

                       }
                   }
               }
           }
       }


   }

    saveFieldValue(fieldValue: string){
       this.editKeyTrackerService.saveFieldValue(this.UserID, this.FieldName, fieldValue).subscribe(
           (result) => {
                this.result = result;
                this.fieldValueChange.emit( { ID : this.UserID, KeyValue : fieldValue });
                this.showChange.emit(false);
           }
       )
    }

    public OnShow(){
        this.FieldValue=this.teamMemberCodeValue;
        this.bindFieldChangeHistory();

    }

    onControlClick(event) {
        // If we are clicking the close button and not something else
        if (event.target.className === "fa fa-fw fa-close") {
        }
    }
    bindFieldChangeHistory(): void {
        if (this.UserID == undefined){
            this.UserID = 0;
        }
        this.editKeyTrackerService.getFieldChangeHistory(this.UserID, this.FieldName).subscribe((listFieldChangeHistory) => {
        this.fieldChangeHistory = listFieldChangeHistory;
        });
    }
    omit_special_char(event)
    {
       var k;
      k = event.charCode;
      return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
    }

    // remove self from modal service when directive is destroyed
    ngOnDestroy(): void {
    }
}



// WEBPACK FOOTER //
// ./src/app/Components/edit-key-tracker/edit-key-tracker.component.ts